import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Campaign, Note } from "../types/CampaignDatas"
import "./styles/styles.css"
import {
  TAupdateCampaign,
  TAupdateCampaignLogo,
  TAcampaignLimitationApplications,
  TAsendVoiceMessage,
  TAsendSMS,
  TAsendEmail,
  TAsendWhatsappMessage,
  TAupdateNote,
  TAdeleteNote,
  TAchangeDeleteStatus,
  TAsetVisibility,
  TAgetVoiceMessageInfo,
  TAgetSMSInfo,
  TAgetEmailInfo,
  TAgetWhatsappMessageInfo,
  TAsendOnesignalNotification,
  TAgetOnesignalNotificationInfo,
} from "../services/campaignsAPI"
import { selectUser } from "../redux/store/auth/authSlice"
import UserCard from "./UserCard"
import AddApplicationModal from "./AddApplicationModal"
import CampaignNotesModal from "../pages/Campaign/allCampaigns/components/NotesModal"
import { useNavigate } from "react-router-dom"
import { BrandSubSectorsData } from "../static/Brand"
import { getErrorStatus } from "../types/error"

export const CampaignProfile = (data: Campaign) => {
  const navigate = useNavigate()
  const userEmail = useSelector(selectUser)?.replace(/"/g, "") || ""

  const getSubSectorDisplayName = (value: string | undefined) => {
    if (!value) {
      return "Belirtilmemiş"
    }
    const subSector = BrandSubSectorsData.find((item) => item.value === value)
    return subSector ? subSector.name : value
  }
  const [coverPhoto, setCoverPhoto] = useState(data.cover_photo)
  const [notes, setNotes] = useState<Note[]>(data.notes || [])
  const [isOpen, setIsOpen] = useState(false)
  const [logo_url, setLogo_url] = useState("")
  const [isBarterDropdownOpen, setIsBarterDropdownOpen] = useState(false)
  const [barter, setBarter] = useState(data.barter)
  const [barterDetails, setBarterDetails] = useState(data.barter_details)
  const [barterDescription, setBarterDescription] = useState(data.barter_description)
  const [newBarter, setNewBarter] = useState(data.barter || false)
  const [newBarterDetails, setNewBarterDetails] = useState(data.barter_details || "")
  const [newBarterDescription, setNewBarterDescription] = useState(data.barter_description || "")
  const [showPhoneInWaitingContent, setShowPhoneInWaitingContent] = useState(
    data.showPhoneInWaitingContent ?? true,
  )
  const [showPhoneLoading, setShowPhoneLoading] = useState(false)
  const [suggestedUsers, setSuggestedUsers] = useState([])
  const [page, setPage] = useState(1)
  const [perPage] = useState(10)
  const [totalPages, setTotalPages] = useState(0)
  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false)
  const [voiceStatus, setVoiceStatus] = useState("")
  const [smsStatus, setSmsStatus] = useState("")
  const [emailStatus, setEmailStatus] = useState("")
  const [whatsappStatus, setWhatsappStatus] = useState("")
  const [voiceMessageState, setVoiceMessageState] = useState("waiting_content")
  const [voiceMessageType, setVoiceMessageType] = useState("all")
  const [voiceMessageInfo, setVoiceMessageInfo] = useState<number | null>(null)
  const [voiceInfoLoading, setVoiceInfoLoading] = useState(false)
  const [voiceInfoError, setVoiceInfoError] = useState("")
  const [smsMessageInfo, setSmsMessageInfo] = useState<number | null>(null)
  const [smsInfoLoading, setSmsInfoLoading] = useState(false)
  const [smsInfoError, setSmsInfoError] = useState("")
  const [emailMessageInfo, setEmailMessageInfo] = useState<number | null>(null)
  const [emailInfoLoading, setEmailInfoLoading] = useState(false)
  const [emailInfoError, setEmailInfoError] = useState("")
  const [whatsappMessageInfo, setWhatsappMessageInfo] = useState<number | null>(null)
  const [whatsappInfoLoading, setWhatsappInfoLoading] = useState(false)
  const [whatsappInfoError, setWhatsappInfoError] = useState("")
  const [onesignalStatus, setOnesignalStatus] = useState("")
  const [onesignalMessageInfo, setOnesignalMessageInfo] = useState<number | null>(null)
  const [onesignalInfoLoading, setOnesignalInfoLoading] = useState(false)
  const [onesignalInfoError, setOnesignalInfoError] = useState("")
  const [sendingAction, setSendingAction] = useState<
    "voice" | "sms" | "mail" | "whatsapp" | "onesignal" | null
  >(null)
  const [deleteStatus, setDeleteStatus] = useState(data.deleted || false)
  const [deleteStatusLoading, setDeleteStatusLoading] = useState(false)
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false)
  const [visibility, setVisibility] = useState(data.visibility || false)
  const [visibilityLoading, setVisibilityLoading] = useState(false)
  const [visibilityChanges, setVisibilityChanges] = useState(data.visibility_changes || [])

  const goToPreviousPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const goToNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }

  const handleCampaignLimitationApplications = async (
    id: string,
    page: number,
    perPage: number,
  ) => {
    try {
      const response = await TAcampaignLimitationApplications(id, page, perPage)
      if (response) {
        setSuggestedUsers(response.data.users)
        setTotalPages(response.data.totalPages)
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  useEffect(() => {
    handleCampaignLimitationApplications(data._id, page, perPage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, page, perPage])

  const fetchVoiceMessageInfo = async () => {
    try {
      setVoiceInfoLoading(true)
      setVoiceInfoError("")
      const response: any = await TAgetVoiceMessageInfo(
        data._id,
        voiceMessageState,
        voiceMessageType,
      )
      if (response) {
        setVoiceMessageInfo(response.total ?? 0)
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      } else {
        setVoiceInfoError("Gönderim bilgisi alınamadı")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setVoiceInfoLoading(false)
    }
  }

  useEffect(() => {
    fetchVoiceMessageInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data._id, voiceMessageState, voiceMessageType])

  const fetchSMSMessageInfo = async () => {
    try {
      setSmsInfoLoading(true)
      setSmsInfoError("")
      const response: any = await TAgetSMSInfo(data._id)
      if (response) {
        setSmsMessageInfo(response.total ?? 0)
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      } else {
        setSmsInfoError("Gönderim bilgisi alınamadı")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setSmsInfoLoading(false)
    }
  }

  const fetchEmailMessageInfo = async () => {
    try {
      setEmailInfoLoading(true)
      setEmailInfoError("")
      const response: any = await TAgetEmailInfo(data._id)
      if (response) {
        setEmailMessageInfo(response.total ?? 0)
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      } else {
        setEmailInfoError("Gönderim bilgisi alınamadı")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setEmailInfoLoading(false)
    }
  }

  const fetchWhatsappMessageInfo = async () => {
    try {
      setWhatsappInfoLoading(true)
      setWhatsappInfoError("")
      const response: any = await TAgetWhatsappMessageInfo(data._id)
      if (response) {
        setWhatsappMessageInfo(response.total ?? 0)
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      } else {
        setWhatsappInfoError("Gönderim bilgisi alınamadı")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setWhatsappInfoLoading(false)
    }
  }

  useEffect(() => {
    fetchSMSMessageInfo()
    fetchEmailMessageInfo()
    fetchWhatsappMessageInfo()
    fetchOnesignalMessageInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data._id])

  const fetchOnesignalMessageInfo = async () => {
    try {
      setOnesignalInfoLoading(true)
      setOnesignalInfoError("")
      const response: any = await TAgetOnesignalNotificationInfo(data._id)
      if (response) {
        setOnesignalMessageInfo(response.total ?? 0)
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      } else {
        setOnesignalInfoError("Gönderim bilgisi alınamadı")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setOnesignalInfoLoading(false)
    }
  }

  const handleUpdateNote = async (note: string) => {
    try {
      const campaign: any = await TAupdateNote(data._id, userEmail, note)
      if (campaign) {
        setNotes(campaign.notes || [])
        return campaign.notes || []
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  const handleSendVoiceMessage = async () => {
    try {
      setSendingAction("voice")
      setVoiceStatus("sending")
      const response: any = await TAsendVoiceMessage(data._id, voiceMessageState, voiceMessageType)
      if (response) {
        setVoiceStatus(
          `${voiceMessageState} aşamasındaki başvurulardan ${response.total} kullanıcıdan ${response.successfulCount} kişiye başarılı bir şekilde mesaj gönderildi.`,
        )
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setSendingAction(null)
    }
  }

  const handleSendSMS = async () => {
    try {
      setSendingAction("sms")
      setSmsStatus("sending")
      const response: any = await TAsendSMS(data._id)
      if (response) {
        setSmsStatus(`Toplam ${response.total} kullanıcı için SMS gönderimi denendi.`)
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setSendingAction(null)
    }
  }

  const handleSendEmail = async () => {
    try {
      setSendingAction("mail")
      setEmailStatus("sending")
      const response: any = await TAsendEmail(data._id)
      if (response) {
        setEmailStatus(`Toplam ${response.total} kullanıcı için e-posta gönderimi denendi.`)
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setSendingAction(null)
    }
  }

  const handleSendWhatsapp = async () => {
    try {
      setSendingAction("whatsapp")
      setWhatsappStatus("sending")
      const response: any = await TAsendWhatsappMessage(data._id)
      if (response) {
        setWhatsappStatus(
          `Toplam ${response.total} kullanıcı için WhatsApp mesajı gönderimi denendi.`,
        )
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setSendingAction(null)
    }
  }

  const handleSendOnesignal = async () => {
    try {
      setSendingAction("onesignal")
      setOnesignalStatus("sending")
      const response: any = await TAsendOnesignalNotification(data._id)
      if (response) {
        setOnesignalStatus(
          `Toplam ${response.total} kullanıcı için push bildirimi gönderimi denendi.`,
        )
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setSendingAction(null)
    }
  }

  const handleDeleteNote = async (campaignId: string, index: number) => {
    try {
      const response = await TAdeleteNote(campaignId, index)
      if (response) {
        setNotes(response.notes || [])
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
    }
  }

  const handleToggleDeleteStatus = async () => {
    try {
      setDeleteStatusLoading(true)
      const response = await TAchangeDeleteStatus(data._id, !deleteStatus)
      if (response) {
        setDeleteStatus(!deleteStatus)
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
    } finally {
      setDeleteStatusLoading(false)
    }
  }

  const handleToggleVisibility = async () => {
    try {
      setVisibilityLoading(true)
      const response = await TAsetVisibility(data._id, !visibility)
      if (response) {
        setVisibility(!visibility)
        setVisibilityChanges(response.campaign)
        // Also update the data object for consistency
        data.visibility_changes = response.campaign
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
    } finally {
      setVisibilityLoading(false)
    }
  }

  const handleUploadPhoto = async (logo_url: any) => {
    try {
      const response = await TAupdateCampaign(data._id, { cover_photo: logo_url })
      if (response) {
        setCoverPhoto(response.campaign.cover_photo)
      }
      setIsOpen(false)
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  const handleSelectPhotoFromPC = async () => {
    try {
      const input = document.createElement("input")
      input.type = "file"
      input.accept = "image/*"
      input.onchange = async (e) => {
        if (!(e.target instanceof HTMLInputElement) || !e.target.files) {
          return
        }

        try {
          const file = e.target.files[0]
          if (!file) {
            return
          }
          const response = await TAupdateCampaignLogo(data._id, file)
          if (response.status !== 200) {
            throw new Error("Failed to upload cover photo")
          }

          if (response) {
            setCoverPhoto(response.data.campaign.cover_photo)
            setIsOpen(false)
          }
        } catch (error: unknown) {
          if (getErrorStatus(error) === 401) {
            navigate("/login")
          }
        }
      }
      input.click()
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
    }
  }

  const handleUpdateBarter = async (_id: string) => {
    try {
      const res = await TAupdateCampaign(_id, {
        barter: newBarter,
        barter_details: newBarterDetails,
        barter_description: newBarterDescription,
      })
      if (res) {
        setBarter(newBarter)
        setBarterDetails(newBarterDetails)
        setBarterDescription(newBarterDescription)
      }
      setIsBarterDropdownOpen(false)
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
    }
  }

  const handleToggleShowPhone = async () => {
    try {
      setShowPhoneLoading(true)
      const newValue = !showPhoneInWaitingContent
      const res = await TAupdateCampaign(data._id, {
        showPhoneInWaitingContent: newValue,
      })
      if (res) {
        setShowPhoneInWaitingContent(newValue)
      }
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
    } finally {
      setShowPhoneLoading(false)
    }
  }

  const messageActions = [
    {
      key: "voice",
      title: "Sesli Mesaj Gönder",
      description: "Belirli aşamadaki kullanıcılara hızlıca sesli bilgilendirme yapın.",
      icon: "🎙️",
      accentBg: "bg-blue-50",
      accentText: "text-blue-600",
      accentDot: "bg-blue-100",
      buttonLabel: "Sesli Mesaj Gönder",
      enabled: true,
    },
    {
      key: "sms",
      title: "SMS Gönder",
      description: "Kısa mesaj ile hatırlatma veya yönlendirme paylaşın.",
      icon: "📱",
      accentBg: "bg-amber-50",
      accentText: "text-amber-700",
      accentDot: "bg-amber-100",
      buttonLabel: "SMS Gönder",
      enabled: true,
    },
    {
      key: "mail",
      title: "Mail Gönder",
      description: "Ayrıntılı bilgilendirme için e‑posta ile ulaşın.",
      icon: "✉️",
      accentBg: "bg-emerald-50",
      accentText: "text-emerald-700",
      accentDot: "bg-emerald-100",
      buttonLabel: "E-Posta Gönder",
      enabled: true,
    },
    {
      key: "whatsapp",
      title: "Whatsapp Mesajı Gönder",
      description: "Hızlı dönüş almak için WhatsApp üzerinden mesaj bırakın.",
      icon: "💬",
      accentBg: "bg-green-50",
      accentText: "text-green-700",
      accentDot: "bg-green-100",
      buttonLabel: "Whatsapp Mesaj Gönder",
      enabled: true,
    },
    {
      key: "onesignal",
      title: "Mobil Bildirim Gönder",
      description: "Mobil uygulama kullanıcılarına anında mobil bildirim gönderin.",
      icon: "🔔",
      accentBg: "bg-purple-50",
      accentText: "text-purple-700",
      accentDot: "bg-purple-100",
      buttonLabel: "Mobil Bildirim Gönder",
      enabled: true,
    },
  ]

  return (
    <div>
      <div className="p-6 w-full rounded-2xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Kampanya Bilgileri</h3>
            {coverPhoto && (
              <div className="flex items-center">
                <img src={coverPhoto} alt="Brand Logo" className="w-28 h-28 rounded-full mr-4" />
                <button
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  onClick={() => setIsOpen(true)}
                >
                  Resmi Değiştir
                </button>
              </div>
            )}
            {!coverPhoto && (
              <div
                className="w-20 h-20 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 text-sm font-bold cursor-pointer"
                onClick={() => setIsOpen(true)}
              >
                Resim Ekle
              </div>
            )}
            {isOpen && (
              <div className="mt-2">
                <input
                  type="text"
                  placeholder="Enter photo url"
                  value={logo_url}
                  onChange={(e) => setLogo_url(e.target.value)}
                  className="border border-gray-400 rounded py-2 px-4 mb-2"
                />
                <button
                  className="bg-blue-500 ml-2 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  onClick={() => handleUploadPhoto(logo_url)}
                >
                  Kaydet
                </button>
                <button
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 ml-2 rounded"
                  onClick={() => handleSelectPhotoFromPC()}
                >
                  Bilgisayardan Yükle
                </button>
              </div>
            )}
            <table className="table-auto w-full">
              <tbody>
                <tr className="border-b">
                  <td className="py-2 font-semibold text-gray-700">Kampanya Id</td>
                  <td className="py-2 text-gray-600">{data._id}</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 font-semibold text-gray-700">Markaya Git</td>
                  <td className="py-2 text-gray-600">
                    <a
                      href={`/brands/find/${data.brand}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded text-sm inline-block"
                    >
                      Marka Profiline Git
                    </a>
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 font-semibold text-gray-700">Kampanya Adı</td>
                  <td className="py-2 text-gray-600">{data.name}</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 font-semibold text-gray-700">Marka Açıklaması</td>
                  <td className="py-2 text-gray-600">{data.brand_description}</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 font-semibold text-gray-700">Ülke</td>
                  <td className="py-2 text-gray-600">{data.country}</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 font-semibold text-gray-700">Platform</td>
                  <td className="py-2 text-gray-600">{data.platform}</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 font-semibold text-gray-700">Adım</td>
                  <td className="py-2 text-gray-600">{data.step}</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 font-semibold text-gray-700">Görünürlük</td>
                  <td className="py-2 text-gray-600">
                    <div className="flex items-center gap-2">
                      <span className={visibility ? "text-green-600" : "text-red-600"}>
                        {visibility ? "Yayında" : "Yayında değil"}
                      </span>
                      <button
                        onClick={handleToggleVisibility}
                        disabled={visibilityLoading}
                        className={`px-3 py-1 rounded text-white text-sm ${
                          visibility
                            ? "bg-red-500 hover:bg-red-600"
                            : "bg-green-500 hover:bg-green-600"
                        } ${visibilityLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        {visibilityLoading ? (
                          <span className="spinner"></span>
                        ) : visibility ? (
                          "Gizle"
                        ) : (
                          "Yayınla"
                        )}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 font-semibold text-gray-700">Silinme Durumu</td>
                  <td className="py-2 text-gray-600">
                    <div className="flex items-center gap-2">
                      <span className={deleteStatus ? "text-red-600" : "text-green-600"}>
                        {deleteStatus ? "Silinmiş" : "Aktif"}
                      </span>
                      <button
                        onClick={handleToggleDeleteStatus}
                        disabled={deleteStatusLoading}
                        className={`px-3 py-1 rounded text-white text-sm ${
                          deleteStatus
                            ? "bg-green-500 hover:bg-green-600"
                            : "bg-red-500 hover:bg-red-600"
                        } ${deleteStatusLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        {deleteStatusLoading ? (
                          <span className="spinner"></span>
                        ) : deleteStatus ? (
                          "Geri Al"
                        ) : (
                          "Sil"
                        )}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="py-2 font-semibold text-gray-700">Onay Durumu</td>
                  <td className="py-2 text-gray-600">
                    {data.is_verified ? "Onaylı" : "Onaylı Değil"}
                  </td>
                </tr>
                <tr>
                  <td className="py-2 font-semibold text-gray-700">Sektör</td>
                  <td className="py-2 text-gray-600">{data.sector}</td>
                </tr>
                <tr>
                  <td className="py-2 font-semibold text-gray-700">Alt Sektör</td>
                  <td className="py-2 text-gray-600">{getSubSectorDisplayName(data.sub_sector)}</td>
                </tr>
                <tr>
                  <td className="py-2 font-semibold text-gray-700">Oluşturulma Tarihi</td>
                  <td className="py-2 text-gray-600">
                    {new Date(data.created_at).toLocaleDateString("tr-TR", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </td>
                </tr>
                <tr>
                  <td className="py-2 font-semibold text-gray-700">Ürün Gönderimi</td>
                  <td className="py-2 text-gray-600">{barter === true ? "Var" : "Yok"}</td>
                  <td colSpan={2}>
                    <button
                      className="bg-blue-500 text-white rounded-md p-2 mt-1 w-full"
                      onClick={() => setIsBarterDropdownOpen(true)}
                    >
                      Güncelle
                    </button>
                  </td>
                </tr>
                {barter && (
                  <>
                    <tr>
                      <td className="py-2 font-semibold text-gray-700">Ürün Gönderim Açıklaması</td>
                      <td className="py-2 text-gray-600">{barterDescription}</td>
                    </tr>
                    <tr>
                      <td className="py-2 font-semibold text-gray-700">Ürün Gönderim Detayları</td>
                      <td className="py-2 text-gray-600">{barterDetails}</td>
                    </tr>
                  </>
                )}
                <tr>
                  <td className="py-2 font-semibold text-gray-700">
                    İçerik Bekleyenlerde Telefon Göster
                  </td>
                  <td className="py-2 text-gray-600">
                    <div className="flex items-center gap-2">
                      <span
                        className={showPhoneInWaitingContent ? "text-green-600" : "text-red-600"}
                      >
                        {showPhoneInWaitingContent ? "Göster" : "Gizle"}
                      </span>
                      <button
                        onClick={handleToggleShowPhone}
                        disabled={showPhoneLoading}
                        className={`px-3 py-1 rounded text-white text-sm ${
                          showPhoneInWaitingContent
                            ? "bg-red-500 hover:bg-red-600"
                            : "bg-green-500 hover:bg-green-600"
                        } ${showPhoneLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        {showPhoneLoading ? "..." : showPhoneInWaitingContent ? "Gizle" : "Göster"}
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            {isBarterDropdownOpen && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white p-4 rounded shadow-lg w-full max-w-xs mx-auto">
                  <h2 className="text-lg font-bold mb-4">Kampanya Ürün Gönderimini Güncelle</h2>
                  <div className="max-h-96">
                    {" "}
                    <h3 className="text-md font-bold mb-2">Ürün Gönderimi</h3>
                    <div className="flex flex-row">
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          className="form-radio h-5 w-5 text-blue-600"
                          name="barter"
                          value="true"
                          onChange={() => setNewBarter(true)}
                        />
                        <span className="text-gray-700">Evet</span>
                      </label>
                      <label className="flex items-center cursor-pointer ml-4">
                        <input
                          type="radio"
                          className="form-radio h-5 w-5 text-blue-600"
                          name="barter"
                          value="false"
                          onChange={() => setNewBarter(false)}
                        />
                        <span className="text-gray-700">Hayır</span>
                      </label>
                    </div>
                    {newBarter && (
                      <div>
                        <h3 className="text-md font-bold mb-2 mt-6">Ürün Gönderimi Detayları</h3>
                        <label className="flex items-center cursor-pointer">
                          <textarea
                            className="w-full p-2 border border-gray-200 rounded-md"
                            placeholder="Write barter details"
                            value={newBarterDetails}
                            onChange={(e) => setNewBarterDetails(e.target.value)}
                          />
                        </label>
                        <h3 className="text-md font-bold mb-2">Ürün Gönderimi Açıklaması</h3>
                        <label className="flex items-center cursor-pointer">
                          <textarea
                            className="w-full p-2 border border-gray-200 rounded-md"
                            placeholder="Write barter details"
                            value={newBarterDescription}
                            onChange={(e) => setNewBarterDescription(e.target.value)}
                          />
                        </label>
                      </div>
                    )}
                  </div>
                  <button
                    className="mt-4 bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700"
                    onClick={() => {
                      handleUpdateBarter(data._id)
                    }}
                  >
                    Kaydet
                  </button>
                  <button
                    className="mt-4 ml-12 bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700"
                    onClick={() => setIsBarterDropdownOpen(false)}
                  >
                    Kapat
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="col-span-1 md:col-span-1">
            <div className="bg-white p-4 rounded-lg shadow border border-gray-200 overflow-hidden">
              <h4 className="text-lg font-semibold mb-4 text-gray-700">İçerik Metrikleri</h4>
              <table className="table-auto w-full">
                <tbody>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600 truncate">İçerik Detayları</td>
                    <td className="py-2 text-gray-800 break-words">
                      {Array.isArray(data.content_details)
                        ? data.content_details.join(", ")
                        : data.content_details}
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600 truncate">
                      İçerikte Bahsedilmesi Gerekenler
                    </td>
                    <td className="py-2 text-gray-800 break-words">
                      {Array.isArray(data.content_mentions)
                        ? data.content_mentions.join(", ")
                        : data.content_mentions}
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600 truncate">İçerik Örnek Metni</td>
                    <td className="py-2 text-gray-800 break-words">
                      {Array.isArray(data.content_example_text)
                        ? data.content_example_text.join(", ")
                        : data.content_example_text}
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600 truncate">İçerik Metrikleri</td>
                    <td className="py-2 text-gray-800 break-words">
                      {Array.isArray(data.content_metrics)
                        ? data.content_metrics.join(", ")
                        : data.content_metrics}
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600 truncate">
                      İçerikte Bahsedilmemesi Gerekenler
                    </td>
                    <td className="py-2 text-gray-800 break-words">
                      {Array.isArray(data.mention_awoid)
                        ? data.mention_awoid.join(", ")
                        : data.mention_awoid}
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600 truncate">İçerikte Vurgulanması Gereken</td>
                    <td className="py-2 text-gray-800 break-words">
                      {Array.isArray(data.mention_emphasis)
                        ? data.mention_emphasis.join(", ")
                        : data.mention_emphasis}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-2 text-gray-600 truncate">İçerik Hashtagleri</td>
                    <td className="py-2 text-gray-800 break-words">
                      {Array.isArray(data.content_hashtags)
                        ? data.content_hashtags.join(", ")
                        : data.content_hashtags}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-2 text-gray-600 truncate">İçerik Hesabı</td>
                    <td className="py-2 text-gray-800 break-words">
                      {Array.isArray(data.content_account)
                        ? data.content_account.join(", ")
                        : data.content_account}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-2 text-gray-600 truncate">İçerik Promosyonları</td>
                    <td className="py-2 text-gray-800 break-words">
                      {Array.isArray(data.content_promotions)
                        ? data.content_promotions.join(", ")
                        : data.content_promotions}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <DetailItem label="Açıklama" value={data.description} />

          {/* Limitations */}
          <div className="col-span-1 md:col-span-1">
            <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
              <h4 className="text-lg font-semibold mb-4 text-gray-700">Segmentasyon</h4>
              <table className="table-auto w-6/12">
                <tbody>
                  <tr className="border-b">
                    <td className="py-2">Cinsiyet</td>
                    <td className="py-2">
                      {data.limitations?.gender ? data.limitations?.gender : "Any"}
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2">Yaş</td>
                    <td className="py-2">
                      {data.limitations?.min_age} to {data.limitations?.max_age}
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2">Takipçi</td>
                    <td className="py-2">
                      {data.limitations?.min_follower} to {data.limitations?.max_follower}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-2">Şehir</td>
                    <td className="py-2">{data.limitations?.city || "Any"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Second Row - Notes, Visibility History, and Voice Message */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
          {/* Campaign Notes */}
          <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
            <h4 className="text-lg font-semibold mb-4 text-gray-700">Notlar</h4>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <span className="text-gray-600">
                  Toplam {notes.filter((note) => note.note !== "").length} not
                </span>
                <button
                  onClick={() => setIsNotesModalOpen(true)}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                >
                  Notları Görüntüle
                </button>
              </div>
            </div>
          </div>

          {/* Visibility Changes History */}
          <div className="lg:col-span-2 bg-white p-4 rounded-lg shadow border border-gray-200">
            <div className="flex items-center justify-between mb-4">
              <h4 className="text-lg font-semibold text-gray-700">Görünürlük Değişiklik Geçmişi</h4>
              {visibilityChanges && visibilityChanges.length > 0 && (
                <span className="text-sm text-gray-500">{visibilityChanges.length} değişiklik</span>
              )}
            </div>
            {visibilityChanges && visibilityChanges.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {visibilityChanges
                  .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
                  .map((change, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between p-2 bg-gray-50 rounded-lg border-l-3 border-blue-500 hover:bg-gray-100 transition-colors"
                    >
                      <div className="flex items-center gap-2">
                        <span
                          className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                            change.visibility
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {change.visibility ? "Yayınlandı" : "Gizlendi"}
                        </span>
                        <span className="text-xs text-gray-600 font-medium">
                          {change.visibility ? "Yayında" : "Gizli"}
                        </span>
                      </div>
                      <div className="text-right">
                        <span className="text-xs text-gray-500 font-medium">
                          {new Date(change.date).toLocaleDateString("tr-TR", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                        </span>
                        <div className="text-xs text-gray-400">
                          {new Date(change.date).toLocaleTimeString("tr-TR", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ) : (
              <div className="text-center py-8 text-gray-500">
                <div className="w-12 h-12 mx-auto mb-3 bg-gray-100 rounded-full flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-base font-medium text-gray-700 mb-1">Henüz değişiklik yok</h3>
                <p className="text-sm text-gray-500">
                  Kampanya görünürlüğü değiştirildiğinde burada görünecek
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Third Row - Send Messages */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-lg font-semibold text-gray-800">Toplu Mesaj Gönderimleri</h4>
              <p className="text-sm text-gray-500">
                Kanala göre kullanıcıları seçin ve tek tıkla bilgilendirin.
              </p>
            </div>
            <div className="hidden lg:flex items-center gap-2 text-xs text-gray-500">
              <span className="px-2 py-1 rounded-full bg-gray-100">Segmentasyon</span>
              <span className="px-2 py-1 rounded-full bg-gray-100">Aksiyon</span>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {messageActions.map((action) => {
              const isSending = sendingAction === action.key
              const statusMessage =
                action.key === "voice"
                  ? voiceStatus
                  : action.key === "sms"
                  ? smsStatus
                  : action.key === "mail"
                  ? emailStatus
                  : action.key === "whatsapp"
                  ? whatsappStatus
                  : action.key === "onesignal"
                  ? onesignalStatus
                  : ""

              const handleActionClick = () => {
                if (!action.enabled) {
                  return null
                }
                if (action.key === "voice") {
                  return handleSendVoiceMessage()
                }
                if (action.key === "sms") {
                  return handleSendSMS()
                }
                if (action.key === "mail") {
                  return handleSendEmail()
                }
                if (action.key === "whatsapp") {
                  return handleSendWhatsapp()
                }
                if (action.key === "onesignal") {
                  return handleSendOnesignal()
                }
                return null
              }

              return (
                <div
                  key={action.key}
                  className="bg-white p-5 rounded-xl shadow border border-gray-200/80 hover:shadow-lg transition-all duration-200"
                >
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-start gap-3">
                      <div
                        className={`w-11 h-11 rounded-full flex items-center justify-center text-lg ${action.accentBg} ${action.accentText}`}
                      >
                        {action.icon}
                      </div>
                      <div>
                        <h5 className="text-base font-semibold text-gray-800">{action.title}</h5>
                        <p className="text-sm text-gray-500 leading-relaxed">
                          {action.description}
                        </p>
                      </div>
                    </div>
                    <span className={`w-2 h-2 rounded-full ${action.accentDot}`} />
                  </div>

                  {action.key === "voice" && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-500">Başvuru Aşaması</label>
                        <select
                          value={voiceMessageState}
                          className="w-full p-3 border border-gray-200 rounded-lg bg-gray-50 focus:bg-white focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100 text-sm text-gray-700"
                          onChange={(e) => setVoiceMessageState(e.target.value)}
                        >
                          <option value="waiting_content">İçerik Beklenen</option>
                          <option value="waiting_address">Adres Beklenen</option>
                          <option value="invite_new">Davet Edilen</option>
                        </select>
                      </div>
                      <div className="space-y-1">
                        <label className="text-xs font-medium text-gray-500">Hedef Grup</label>
                        <select
                          value={voiceMessageType}
                          className="w-full p-3 border border-gray-200 rounded-lg bg-gray-50 focus:bg-white focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100 text-sm text-gray-700"
                          onChange={(e) => setVoiceMessageType(e.target.value)}
                        >
                          <option value="all">Hepsi</option>
                          <option value="unaswered">Cevap Vermeyenler</option>
                        </select>
                      </div>
                    </div>
                  )}

                  {action.key === "voice" && (
                    <div className="mt-3 p-3 rounded-lg bg-gray-50 border border-gray-100">
                      <div className="text-xs font-semibold text-gray-600 mb-1">
                        Gönderim ön bilgisi
                      </div>
                      <div className="text-sm text-gray-700">
                        {voiceInfoLoading
                          ? "Hesaplanıyor..."
                          : voiceInfoError
                          ? voiceInfoError
                          : voiceMessageInfo !== null
                          ? `${voiceMessageInfo} kullanıcıya gönderilecek`
                          : "Bilgi alınamadı"}
                      </div>
                    </div>
                  )}

                  <button
                    className="mt-4 w-full inline-flex items-center justify-center gap-2 bg-blue-500 text-white rounded-lg px-4 py-3 hover:bg-blue-600 transition-colors font-medium disabled:opacity-60 disabled:cursor-not-allowed"
                    onClick={handleActionClick}
                    disabled={isSending || !action.enabled}
                  >
                    {isSending ? "Gönderiliyor..." : action.buttonLabel}
                  </button>

                  {action.key === "sms" && (
                    <div className="mt-3 p-3 rounded-lg bg-gray-50 border border-gray-100">
                      <div className="text-xs font-semibold text-gray-600 mb-1">
                        Gönderim ön bilgisi
                      </div>
                      <div className="text-sm text-gray-700">
                        {smsInfoLoading
                          ? "Hesaplanıyor..."
                          : smsInfoError
                          ? smsInfoError
                          : smsMessageInfo !== null
                          ? `${smsMessageInfo} kullanıcıya gönderilecek`
                          : "Bilgi alınamadı"}
                      </div>
                    </div>
                  )}

                  {action.key === "mail" && (
                    <div className="mt-3 p-3 rounded-lg bg-gray-50 border border-gray-100">
                      <div className="text-xs font-semibold text-gray-600 mb-1">
                        Gönderim ön bilgisi
                      </div>
                      <div className="text-sm text-gray-700">
                        {emailInfoLoading
                          ? "Hesaplanıyor..."
                          : emailInfoError
                          ? emailInfoError
                          : emailMessageInfo !== null
                          ? `${emailMessageInfo} kullanıcıya gönderilecek`
                          : "Bilgi alınamadı"}
                      </div>
                    </div>
                  )}

                  {action.key === "whatsapp" && (
                    <div className="mt-3 p-3 rounded-lg bg-gray-50 border border-gray-100">
                      <div className="text-xs font-semibold text-gray-600 mb-1">
                        Gönderim ön bilgisi
                      </div>
                      <div className="text-sm text-gray-700">
                        {whatsappInfoLoading
                          ? "Hesaplanıyor..."
                          : whatsappInfoError
                          ? whatsappInfoError
                          : whatsappMessageInfo !== null
                          ? `${whatsappMessageInfo} kullanıcıya gönderilecek`
                          : "Bilgi alınamadı"}
                      </div>
                    </div>
                  )}

                  {action.key === "onesignal" && (
                    <div className="mt-3 p-3 rounded-lg bg-gray-50 border border-gray-100">
                      <div className="text-xs font-semibold text-gray-600 mb-1">
                        Gönderim ön bilgisi
                      </div>
                      <div className="text-sm text-gray-700">
                        {onesignalInfoLoading
                          ? "Hesaplanıyor..."
                          : onesignalInfoError
                          ? onesignalInfoError
                          : onesignalMessageInfo !== null
                          ? `${onesignalMessageInfo} kullanıcıya gönderilecek`
                          : "Bilgi alınamadı"}
                      </div>
                    </div>
                  )}

                  {statusMessage && (
                    <div className="mt-3 p-3 rounded-lg bg-blue-50 border border-blue-100 text-sm text-blue-700">
                      {statusMessage === "sending" ? "Mesaj gönderiliyor..." : statusMessage}
                    </div>
                  )}

                  {!action.enabled && (
                    <div className="mt-3 text-xs text-gray-400 text-center">
                      Yakında hizmete açılacak
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
        <DetailItem label="Reddedilme Sebebi" value={data.rejected_reason || "-"} />
      </div>
      <div>
        {suggestedUsers.length > 0 ? (
          <div>
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Önerilen Kullanıcılar</h3>
            <div className="overflow-x-auto py-4">
              <div className="flex space-x-4">
                {suggestedUsers.map((user, index) => (
                  <UserCard
                    key={index}
                    user={user}
                    campaign_id={data._id}
                    campaign_type={data.platform}
                  />
                ))}
                <div className="flex-shrink-0 w-60 p-4 bg-white shadow-md rounded-lg border border-gray-200 hover:shadow-xl transition-shadow duration-300">
                  <div onClick={() => setIsApplicationModalOpen(true)}>
                    <img
                      src="https://www.gravatar.com/avatar/?d=mp&f=y&s=150"
                      alt="User avatar placeholder"
                      className="w-16 h-16 rounded-full object-cover mx-auto mb-4"
                    />
                    <div className="flex items-center justify-center mt-4">
                      <button
                        className="text-blue-600 font-semibold cursor-pointer"
                        onClick={() => setIsApplicationModalOpen(true)}
                      >
                        <h3 className="text-center text-lg font-semibold">
                          Yeni Kullanıcı Oluştur
                        </h3>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <AddApplicationModal
              isOpen={isApplicationModalOpen}
              onClose={() => setIsApplicationModalOpen(false)}
              _id={data._id}
              currency="TRY"
            />
            <div className="flex justify-center items-center mt-4 space-x-4">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 disabled:bg-gray-200 disabled:text-gray-500"
                onClick={goToPreviousPage}
                disabled={page === 1}
              >
                Önceki
              </button>
              <span className="text-gray-700">
                Page {page} of {totalPages}
              </span>
              <button
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 disabled:bg-gray-200 disabled:text-gray-500"
                onClick={goToNextPage}
                disabled={page === totalPages}
              >
                Sonraki
              </button>
            </div>
          </div>
        ) : (
          <p className="text-center text-gray-600">Önerilen Kullanıcı Yok</p>
        )}
      </div>

      <CampaignNotesModal
        isOpen={isNotesModalOpen}
        onClose={() => setIsNotesModalOpen(false)}
        campaignId={data._id}
        notes={notes}
        onAddNote={handleUpdateNote}
        onDeleteNote={handleDeleteNote}
      />
    </div>
  )
}

const DetailItem: React.FC<{ label: string; value: string | number }> = ({ label, value }) => (
  <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
    <h5 className="text-md font-semibold mb-1 text-gray-700">{label}</h5>
    <p className="text-gray-600">{value}</p>
  </div>
)

export default CampaignProfile
